var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDesktop = function SvgDesktop(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 19",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 15.5q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 13.5v-11q0-.825.588-1.413A1.93 1.93 0 0 1 3 .5h16q.825 0 1.413.587Q21 1.675 21 2.5v11q0 .825-.587 1.413A1.93 1.93 0 0 1 19 15.5zm0-2h16v-11H3zm-2 5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 0 17.5q0-.424.288-.712A.97.97 0 0 1 1 16.5h20q.424 0 .712.288A.97.97 0 0 1 22 17.5q0 .424-.288.712A.97.97 0 0 1 21 18.5zm2-5v-11z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDesktop);
export { ForwardRef as Icon };
export default "img/element-icons/settings/desktop.05314b6.svg";